import React from 'react';
import SEO from "../common/SEO";
import Layout from '../common/Layout';
import SectionTitle from '../elements/sectionTitle/SectionTitle';
import SectionTitleTwo from '../elements/sectionTitle/SectionTitleTwo'
import LeadersWordTestamonial from '../Testamonial/LeadersWordTestamonial';
import { GET_ROLE_DISPATCHING_BY_UNIT_SHORTNAME } from '../data/GraphHooks/useChapterMembers';
import Teamm from '../elements/team/teamm';
import { useQuery } from '@apollo/client';

const Team = () => {
    const roleDispatching = useQuery(GET_ROLE_DISPATCHING_BY_UNIT_SHORTNAME, {variables: { unitShortname: 'SB'}})
    return (
        <>
            <SEO title="Team IEEE ISSAT Sousse || Team IEEE ISSATSo" />
            <main className="page-wrapper">
            <Layout>
            {/* Start Team Area  */}
            <div className="rwt-team-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Student Branch Board members"
                                        title = "Meet The Team"
                                        description = "A highly motivated executive board"
                                    />
                            </div>
                        </div>
                        {roleDispatching.data && (
                            <Teamm column="col-lg-4 col-md-6 col-12" teamStyle="team-style-default style-two" data={roleDispatching.data.rd} />
                        )}
                    </div>
                </div>
                {/* End Team Area  */}
                
                {/* Start Elements Area  */}
                <div className="rwt-testimonial-area rn-section-gapBottom">
                    <div className="container">
                        <div className="row mb--20">
                            <div className="col-lg-12">
                                <SectionTitleTwo
                                    Title= "Leaders Statements."
                                    textAlign= "text-left"
                                />
                            </div>
                        </div>
                        <LeadersWordTestamonial column="col-lg-4 col-md-6 col-12" teamStyle="card-style-default testimonial-style-one style-two border-gradient" />
                    </div>
                </div>
    {/* End Elements Area  */}
            </Layout>
            </main>
        </>
    )
}

export default Team;
